import { MarketingModals } from "app/components/modals/marketing-modals/MarketingModals";
import { PageTopBanner } from "app/components/PageTopBanner/PageTopBanner";
import { HomeWithData } from "app/pages/activation/components/HomeWithData";

import { HomeContextProvider } from "../../context/Home/HomeContext";

const Home = () => {
    return (
        <HomeContextProvider>
            <PageTopBanner />
            <HomeWithData />
            <MarketingModals />
        </HomeContextProvider>
    );
};

export default Home;
